import React, { useState } from 'react';
import { X } from 'lucide-react';

// TagInput — defined OUTSIDE any page to prevent focus loss on re-render
export const TagInput = ({ value = [], onChange }) => {
  const [inputValue, setInputValue] = useState('');
  const addTag = (raw) => {
    const trimmed = raw.trim().toLowerCase().replace(/[,;]+$/, '');
    if (trimmed && !value.includes(trimmed)) onChange([...value, trimmed]);
    setInputValue('');
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); addTag(inputValue); }
    else if (e.key === 'Backspace' && !inputValue && value.length > 0) onChange(value.slice(0, -1));
  };
  return (
    <div className="border border-gray-200 rounded-lg p-2 flex flex-wrap gap-1.5 min-h-[42px] focus-within:ring-2 focus-within:ring-levelup-accent bg-white cursor-text">
      {value.map(tag => (
        <span key={tag} className="flex items-center gap-1 bg-levelup-accent/20 text-levelup-darker text-xs font-medium px-2 py-1 rounded-full">
          #{tag}
          <button type="button" onClick={() => onChange(value.filter(t => t !== tag))} className="text-levelup-darker/50 hover:text-levelup-darker">
            <X size={10} />
          </button>
        </span>
      ))}
      <input
        type="text"
        value={inputValue}
        onChange={e => setInputValue(e.target.value.replace(/,/g, ''))}
        onKeyDown={handleKeyDown}
        onBlur={() => inputValue.trim() && addTag(inputValue)}
        placeholder={value.length === 0 ? 'Add tags — press Enter or comma to confirm (e.g. copilot, azure)' : 'Add more…'}
        className="flex-1 min-w-[140px] text-sm outline-none bg-transparent py-0.5"
        data-testid="search-tags-input"
      />
    </div>
  );
};
